import { Feature, Permission } from '@core/models';

export function getModuleLandingCommands(moduleSlug: string, hasProjects: boolean, permissions: Permission[], features: Feature[]): string[] {
    if (hasProjects) {
        return ['/', moduleSlug, 'home'];
    }

    if (permissions.includes(Permission.ViewContacts)) {
        return ['/', moduleSlug, 'contacts'];
    }

    if (permissions.includes(Permission.ViewResults) && features.includes(Feature.ResultsPage)) {
        return ['/', moduleSlug, 'results', 'table'];
    }

    if (permissions.includes(Permission.ViewAnalytics)) {
        return ['/', moduleSlug, 'results', 'analytics'];
    }

    return ['/user'];
}
